import GlobState from "globstate";
import $ti from './ti.js';
import { v4 as uuidv4 } from 'uuid';

import allTemplates from "./templates.js"

let iOptions = {
  // API_URL: 'http://impetus.vladislove.uz/api',
  API_URL: 'http://impetus.my/api',
};
if (typeof window !== "undefined") {
  window.iOptions = iOptions
}

class Globals extends GlobState {
  
  device_id = null;
  templates = null;
  activeTemplate = null;
  activeMarathon = null;
  activeTest = null;
 
  user = null;
  lang = 'ru';

  API_URL = null;

  constructor() {
    super("Globals");
    this.lang = this.deviceId();
    this.device_id = this.deviceId();
    this.API_URL = window.iOptions ? window.iOptions.API_URL : iOptions;
  }

  deviceId = (setDeviceId) => {
    if (typeof device != 'undefined') {
      if (device.uuid) {
        return device.uuid;
      }
    }
    if (setDeviceId) {
      this.device_id = setDeviceId;
      return this.device_id;
    }
    let device_id = localStorage.getItem('impd');
    if (device_id) {
      return device_id;
    }
    let genId = uuidv4();
    localStorage.setItem('impd',genId);
    return genId;
  }

  init() {
    this.getTemplates()
  }

  setUser(data) {
    this.user = data;
    this.isLogin = true;
    this.updateComponents();
  }

  getTemplates() {
    this.templates = allTemplates;
    this.updateComponents();
  }

  Templates() {
    return this.templates;
  }

}

export default new Globals();
